import React from 'react';
import { PageContainer, PageHeader, TabShell, TabShellTab } from '../components/ui';
import { useAppTranslation } from '../i18n/useAppTranslation';
import { useUrlTab } from '../hooks/useUrlTab';
import AdminOrganizationGroupsPage from './AdminOrganizationGroupsPage';
import BrandVendorsGroupApplicationsPage from './brandsVendors/BrandVendorsGroupApplicationsPage';

const TAB_KEYS = ['groups', 'applications'] as const;
type GroupsTabKey = (typeof TAB_KEYS)[number];

/**
 * One page for managed groups: the groups Motzu runs (Groups) and the
 * self-serve signups waiting for review (Applications). Both used to be
 * separate pages under the same title.
 */
export const AdminOrganizationGroupsHubPage: React.FC = () => {
  const { t } = useAppTranslation();
  const [activeTab, setActiveTab] = useUrlTab(TAB_KEYS, 'groups');

  const tabs: TabShellTab<GroupsTabKey>[] = [
    { key: 'groups', label: t('admin.organizationGroups.tabs.groups') },
    { key: 'applications', label: t('admin.organizationGroups.tabs.applications') },
  ];

  return (
    <PageContainer>
      <PageHeader
        title={t('admin.organizationGroups.title')}
        description={t('admin.organizationGroups.description')}
      />
      <TabShell
        tabs={tabs}
        value={activeTab}
        onChange={setActiveTab}
        sticky={false}
        aria-label={t('admin.organizationGroups.title')}
      >
        {activeTab === 'groups' ? (
          <AdminOrganizationGroupsPage embedded />
        ) : (
          <BrandVendorsGroupApplicationsPage embedded />
        )}
      </TabShell>
    </PageContainer>
  );
};

export default AdminOrganizationGroupsHubPage;
